module.exports = __webpack_public_path__ + "assets/img/enterprise-logo.10c965ad.png";